export default __webpack_public_path__ + "static/media/App.6101b8a3.less";